import { ADD_RECOMMENDED } from "./actions";

const initialState = {
};

const recommendedReducer = (state = initialState, action) => {
    const {
        type, 
        recommended,
    } = action;
  
    switch (type) {
        case ADD_RECOMMENDED:
            return { 
                ...state, 
                recommended
            };
        default:{
            return state;
        }
    }
};

export default recommendedReducer;
